import axios from 'axios'
//仓库下拉列表
export function getWarehousePullDownList (data) {
  return axios.get(`/manage/warehouse/queryDropDownBox`, { params: data })
}
//库区下拉列表
export function getWarehouseAreaPullDownList (data) {
  return axios.get(`/manage/wmsStorageArea/queryDropDownBox`, { params: data })
}
//入库统计列表
export function getWarehouseSkinList (data) {
  return axios.get(`/manage/productInboundDetail/list`, { params: data })
}
//入库统计详情
export function getWarehouseDetail (ids) {
  return axios.get(`/manage/productInboundDetail/${ids}`)
}
//入库统计上传图片
export function uploadWarehouse (data) {
  return axios.post('/system/file/upload', data)
}
//入库统计保存图片
export function uploadSaveWarehouse (data) {
  return axios.post('/manage/productInboundDetail/savePicture', data)
}

//入库统计容器明细详情
export function getWarehouseStorageDetail (data) {
  return axios.get(`/manage/productInboundDetail/getCheckRecord`, { params: data })
}
